// extracted by mini-css-extract-plugin
module.exports = {"inputNumber":"ModalSettlements_inputNumber__2bDW8"};